import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from '@/components/Avatar/Avatar';
import styles from './Message.module.scss';
export const Audio = ({ url, avatar }) => {
    return (_jsxs(_Fragment, { children: [_jsx(Avatar, { avatar: avatar }), _jsx("audio", { className: styles.audio, controls: true, src: url })] }));
};
